import { FormattedMessage } from 'react-intl';

import { IconButton } from '@xing-com/button';
import { ReportButton } from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { IconMore, IconSpam } from '@xing-com/icons';
import { usePopOver } from '@xing-com/pop-over';

import { ArticleCardView } from '../../../types/types';

import * as Styled from './article-more-menu.styles';

type Props = {
  article: ArticleCardView;
};
export const ArticleMoreMenu: React.FC<Props> = ({ article }) => {
  const rightBarPopOver = usePopOver();
  const { pageContext } = usePageContext();

  return (
    <>
      <IconButton
        ref={rightBarPopOver.triggerRef}
        icon={IconMore}
        onClick={rightBarPopOver.togglePopOver}
        data-testid="ARTICLE-CARD-RIGHT-SOCIAL-MENU"
      />
      <Styled.RightSocialMenu
        onOutsideClick={rightBarPopOver.handleHide}
        show={rightBarPopOver.show}
        triggerRef={rightBarPopOver.triggerRef}
      >
        <ReportButton
          icon={IconSpam}
          size="medium"
          authorUrn={article.globalId}
          targetUrn={pageContext.globalId}
        >
          <FormattedMessage id="EP_ARTICLES_MODULE_REPORT_BUTTON" />
        </ReportButton>
      </Styled.RightSocialMenu>
    </>
  );
};
